// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2J7Wd","buttons":"styles_buttons__35_BM"};